












































import Vue from 'vue';

export default Vue.extend({
  props: {
    currentStep: Number,
    showThirdStep: Boolean,
    showSingleTitle: Boolean,
  },
});
